// src/components/LookupUmat.js
import React from "react";
import LookupBase from "./LookupBase";
import * as FS from "../styles/formStyles";
import { resolveUmatAvatarSync, getUmatDisplayLabel } from "../utils/wkCommon";

export default function LookupUmat(props) {
  const endpoint = "/api/umats";

  // new props (optional):
  // props.filterLinked : boolean (default false) -> jika true, tambahkan filter agar umat tanpa qiu mapping saja
  // props.linkedField : string (default "qiu_dao_person") -> nama field relasi untuk memeriksa null
  const {
    filterLinked = false,
    linkedField = "qiu_dao_person",
    includePassedAway = false,
    ...restProps
  } = props;

  function queryBuilder(s) {
    const q = encodeURIComponent(s);
    // base filters
    let base =
      `?filters%5B$or%5D%5B0%5D%5BumatID%5D%5B$containsi%5D=${q}` +
      `&filters%5B$or%5D%5B1%5D%5BnickName%5D%5B$containsi%5D=${q}` +
      `&filters%5B$or%5D%5B2%5D%5BfullName%5D%5B$containsi%5D=${q}` +
      `&filters%5B$or%5D%5B3%5D%5BchineseName%5D%5B$containsi%5D=${q}` +
      `&filters%5B$or%5D%5B4%5D%5BpinyinName%5D%5B$containsi%5D=${q}` +
      `&filters%5B$or%5D%5B5%5D%5BdisplayName%5D%5B$containsi%5D=${q}`

    // exclude passedAway by default
    if (!includePassedAway) {
      base += `&filters%5B%24or%5D%5B1%5D%5BpassedAway%5D%5B%24eq%5D=false` + 
              `&filters%5B%24or%5D%5B1%5D%5BpassedAway%5D%5B%24null%5D=true`;

    }

      // 🔥 tambahkan ini
    base +=  `&fields[0]=umatID` +
      `&fields[1]=chineseName` +
      `&fields[2]=pinyinName` +
      `&fields[3]=fullName` +
      `&fields[4]=nickName` +
      `&fields[5]=gender` +
      `&fields[6]=LoginEmail` + 

      // area
      `&populate[area][fields][0]=name` +

      // avatar
      `&populate[profilepic]=true` +

      /* 🔥 dynamic populate linked field */
      (linkedField
        ? `&populate[${encodeURIComponent(linkedField)}]=true`
        : "")
              
    // if caller wants to exclude umat yang sudah memiliki link, add filter: filters[linkedField][$null]=true
    if (filterLinked) {
      // encode `filters[<linkedField>][$null]=true` as percent-encoded brackets
      const enc = `&filters%5B${encodeURIComponent(linkedField)}%5D%5B%24null%5D=true`;
      base += enc;
    }

    return base;
  }

  function getUmatSubtitle(u) {
    const parts = [];

    if (u?.umatID) parts.push(u.umatID);
    if (u?.gender) parts.push(u.gender);
    if (u?.area?.name) parts.push(u.area.name);

    return parts.join(" | ");
  }

  function renderItem(item) {
    const avatarUrl = resolveUmatAvatarSync(item);
    const title = getUmatDisplayLabel(item);
    const subtitle = getUmatSubtitle(item);

    return (
      <>
        <div style={FS.choiceAvatar}>
          <img
            src={avatarUrl}
            alt={title}
            style={{
              width: "3rem",
              height: "3rem",
              objectFit: "cover",
              borderRadius: "0.375rem"
            }}
          />
        </div>

        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 600 }}>
            {title}
          </div>
          <div style={{ fontSize: "0.875rem", color: "#6b7280" }}>
            {subtitle}
          </div>
        </div>
      </>
    );
  }

  function renderChip(it, onDelete) {
    return (
      <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
        <div style={{ fontWeight: 600 }}>
          {getUmatDisplayLabel(it)}
        </div>
        <button
          onClick={onDelete}
          style={{
            border: "none",
            background: "transparent",
            cursor: "pointer",
            color: "#6b7280"
          }}
          aria-label="remove"
        >
          ×
        </button>
      </div>
    );
  }

  // pass through other props unchanged — keeps backward compatibility
  return <LookupBase endpoint={endpoint} queryBuilder={queryBuilder} renderItem={renderItem} renderChip={renderChip} {...restProps} />;
}
